import { ListIssuerTypes } from "@/graphql/queries.js";
import { API, graphqlOperation } from "aws-amplify";
export const GetAllIssuerTypes = {
  data() {
    return {
      overlay: false,
      noDataText: "",
      GetAllIssuerTypesList: [],
    };
  },
  methods: {
    async GetAllIssuerTypesMethod() {
      try {
        this.overlay = true;
        let result = await API.graphql(
          graphqlOperation(ListIssuerTypes, {
            input: {},
          })
        );
        this.GetAllIssuerTypesList = JSON.parse(
          result.data.ListIssuerTypes
        ).data.items;
        console.warn("GetAllIssuerTypesList", this.GetAllIssuerTypesList);
        this.overlay = false;
      } catch (error) {
        this.overlay = false;
        this.noDataText = error.errors[0].message;
      }
    },
  },
};
